import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { PageHeader, PageFooter } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Page.module.scss";

export interface PageComponentProps extends PlatformComponentProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  title?: string;
  subtitle?: string;
  onBackClick?: () => void;
}
export const Page = ({
  children,
  className,
  header,
  footer,
  title,
  subtitle,
  onBackClick,
}: PageComponentProps) => {
  const COMPONENT_KEY = CoreUiComponents.Page;
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("header")}>
        {header != null ? (
          header
        ) : (
          <PageHeader
            title={title}
            subtitle={subtitle}
            onBackClick={onBackClick}
          />
        )}
      </div>
      <div className={cn("content")}>{children}</div>
      {footer != null ? (
        footer
      ) : (
        <div className={cn("footer")}>
          <PageFooter />
        </div>
      )}
    </div>
  );
};
